import { token } from '@cp/shared/di';
import { ClientSelectionService, ClientSelectionStorage } from './model';

export const SELECTION_STORAGE = token<ClientSelectionStorage>('clientSelection/STORAGE');
export const SELECTION_SERVICE = token<ClientSelectionService>('clientSelection/SERVICE');
